import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, MenuItem, Select, Typography } from '@mui/material';
import { genericMemo } from 'console/shared/utils/memo';
import { useCallback } from 'react';
import { CustomIcon } from '../../icon/custom';
import { getDropdownCustomIcons, } from '../utils';
export const IconDropdown = genericMemo(function IconDropdown(props) {
    const { icons } = props;
    const custom_icons = getDropdownCustomIcons(icons);
    const null_str = '[null]';
    const onChange = useCallback((ev) => {
        if (ev.target.value == null_str)
            props.onChange(0);
        else
            props.onChange(+ev.target.value);
    }, [props.onChange]);
    return (_jsx(Select, { fullWidth: true, margin: "dense", label: props.label, value: props.value.toString(), onChange: onChange, disabled: !!props.disabled, children: custom_icons.map(({ text, Icon, value }, i) => (_jsx(MenuItem, { value: value ?? null_str, children: _jsxs(Box, { display: "flex", alignItems: "center", children: [Icon ? _jsx(CustomIcon, { Icon: Icon }) : null, _jsx(Box, { ml: 2, children: _jsx(Typography, { variant: "subtitle1", color: "textPrimary", fontStyle: Icon ? 'normal' : 'italic', children: Icon ? text : 'Без значка' }) })] }) }, i))) }));
});
